export default {
  'EditArtistOverviewTag.addTag': { en: 'Add Tags', fr: 'Ajouter des balises' },
  'EditArtistOverviewTag.addKeywords': {
    en: 'Add Keywords',
    fr: 'Ajouter des mots clés',
  },
};
